var _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 19,
    viewBox: "0 0 5 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#A6A6A6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 9.5,
    r: 2.5,
    fill: "#A6A6A6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 16.5,
    r: 2.5,
    fill: "#A6A6A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings_icon.6ef133308a1ebfc52c4818dd25e5f97f.svg";
export { ForwardRef as ReactComponent };